<div class="status-container">
    <ng-container *ngIf="priority && recheck; else onlyRecheck">
        <!-- Case 1: both exist -->
        <div class="status-content">
            <div class="box-status-split" [ngStyle]="{'background': background,'color': color}">
                {{ priority }}
            </div>
            <div class="box-status-split" [ngStyle]="{'background': backgroundRecheck,'color': colorRecheck}">
                {{ recheck }}
            </div>
        </div>
    </ng-container>

    <!-- Case 2: only recheck -->
    <ng-template #onlyRecheck>
        <ng-container *ngIf="(recheck); else singleBox">
            <div class="box-status" [ngStyle]="{'background': backgroundRecheck,'color': colorRecheck}">
                {{ recheck }}
            </div>
        </ng-container>
    </ng-template>

    <!-- Case 3: only priority -->
    <ng-template #singleBox>
        <div class="box-status" [ngStyle]="{'background': background,'color': color}">
            {{ priority }}
        </div>
    </ng-template>
</div>